module.exports = __webpack_public_path__ + "static/media/2021_Cadillac_XT6_ext_03_6NV26_1SA_GLR.6f1315b7.png";